import { create } from 'zustand';
import JawsCorrection from '@correction/three/JawsCorrection.ts';

export interface CorrectionState {
  tick: number;
  jaws: JawsCorrection;
  setJaws: (jawsCorrection: JawsCorrection) => void;

  updateStore: () => void;
  resetToothPos: () => void;
  resetToothRot: () => void;

  reset: () => void;
}

export const correctionStore = create<CorrectionState>((set, get) => ({
  tick: 0, // dummy counter
  jaws: null!,
  setJaws: (jaws) => set({ jaws: jaws }),

  // every call truly changes `tick` → Zustand emits new state → React re-renders
  updateStore: () => set((state) => ({ tick: state.tick + 1 })),

  resetToothPos: () => {
    const t = get().jaws.activeTooth;
    t && t.resetPosition();
    set((state) => ({ tick: state.tick + 1 }));
  },

  resetToothRot: () => {
    const t = get().jaws.activeTooth;
    t && t.resetRotation();
    set((state) => ({ tick: state.tick + 1 }));
  },

  reset: () => set({ 
    tick: 0,
    jaws: null!,
  }),
}));
